import { Expose } from "class-transformer";

export enum PlanType {
  FREE = "FREE",
  PAID = "PAID",
  TEMPORARY_USER = "TEMPORARY_USER"
}

export enum ExpirationUnit {
  DAYS = "DAYS",
  MONTHS = "MONTHS",
  HOURS = "HOURS",
  MINUTES = "MINUTES"
}

export class PlanModel {
  @Expose()
  id!: string;

  @Expose()
  name!: string;

  @Expose()
  description?: string;

  @Expose()
  type!: PlanType;

  @Expose()
  monthlyPrice?: number;

  @Expose()
  annualPrice?: number;

  @Expose()
  aiRequestsLimit?: number;

  @Expose()
  tokensLimit?: number;

  @Expose()
  maxPrivateDocuments?: number;

  @Expose()
  maxPublicDocuments?: number;

  @Expose()
  maxSharedDocuments?: number;

  @Expose()
  maxSeats?: number;

  @Expose()
  expirationPeriod?: number;

  @Expose()
  expirationUnit?: ExpirationUnit;

  @Expose()
  allowApiKeys!: boolean;

  @Expose()
  allowAutoRenew!: boolean;

  @Expose()
  stripeMonthlyPriceId?: string;

  @Expose()
  stripeAnnualPriceId?: string;

  @Expose()
  stripeProductId?: string;

  @Expose()
  isPublic!: boolean;

  @Expose()
  isEnabled?: boolean;

  @Expose()
  maxTempUsers?: number;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;

  constructor(model: Partial<PlanModel>) {
    Object.assign(this, model);
  }
}
